<div *ngIf="viewAVCInvoices; else noPermissions">
  <p class="no-results"></p>
  <div *ngIf="allData.size === 0 && !loadingError" i18n="@@documents.accountInvoicesNoInvoices">
    There are no invoices
  </div>

  <div *ngIf="shouldDisplayOfficeSelector()">
    <h1>Your invoices</h1>
    <span>
        <ngb-alert dfInsertAlertIcon *ngIf="alert() as currentAlert" [type]="currentAlert.type" [dismissible]="true" (closed)="closeAlert()">
          <span [innerHTML]="currentAlert.message"></span>
        </ngb-alert>
      </span>
    <form>
      <div class="mb-6 mt-6 dropdown-width">
        <label for="officeSelect" class="form-label" i18n="@@amadeus-direct.avc-invoices.office">Office</label>
        <ng-select
          labelForId="agencySelect"
          [selectOnTab]="true"
          name="officeSelect"
          [items]="officesList"
          [(ngModel)]="selectedOffice"
          [searchable]="true"
          [clearable]="false"
          [markFirst]="true"
          (ngModelChange)="onOfficeChange($event)"
        ></ng-select>
      </div>
    </form>
  </div>
  <label for="invoicesTable" class="form-label" i18n="@@amadeus-direct.avc-invoices.billing-documents">Billing documents</label>
  <div class="card h-100" *ngIf="allData.size !== 0 && !loadingError">
    <div class="card-body">
    <table class="table">
        <thead>
            <tr>
                <th class="pl-3 align-middle" i18n="@@amadeus-direct.avc-invoices.month">Month</th>
                <th class="pl-3 align-middle" i18n="@@amadeus-direct.avc-invoices.invoiceDownload">Invoice download</th>
                <th class="pl-3 align-middle" i18n="@@amadeus-direct.avc-invoices.billingReportDownload">
                  Billing report download
                </th>
            </tr>
        </thead>    

        <tbody>
            <tr *ngFor="let entry of allData | keyvalue: asIsOrder">
              <td class="pl-3 align-middle">
                {{ getMonthFromMonthYear(entry.value.monthYear) + ' ' + getYearFromMonthYear(entry.value.monthYear) }}
              </td>

              <td>
                <div ngbDropdown class="invoice-download-icon-container" *ngIf="entry.value.invoices?.length > 0">
                  <button
                    class="btn df-btn-icononly invoice-download-icon df-standalone-dropdown-toggle"
                    id="dropdownStandalone2"
                    ngbDropdownToggle
                    ngbTooltip="{{ downloadInvoicePdf }}"
                    tooltipClass="text-nowrap"
                    aria-label="More options"
                  ><span class="icon-df-download invoice-download-icon-span"></span></button>
                  <div ngbDropdownMenu aria-labelledby="dropdownStandalone2">
                    <a
                      ngbDropdownItem
                      *ngFor="let invoice of entry.value.invoices; index as id"
                      class="dropdown-item"
                      download
                      [href]="invoice.url"
                    >
                      {{ invoice.name }}
                  </a>
                  </div>
                </div>

              <div
                class="text-muted invoice-download-icon-container d-table text-center"
                *ngIf="!(entry.value.invoices?.length > 0)"
                ngbTooltip="{{ noInvoicePdf }}"
                href="javascript:void(0)"
                ><div class="icon-df-download disabled-icon d-table-cell align-middle"></div
              ></div>
              </td>

              <td>
                  <a
                  class="btn 
                        df-btn-icononly 
                        billing-report-download-icon 
                        billing-report-download-icon-container"
                  *ngIf="entry?.value?.billingReport?.url?.length > 0"
                  [href]="entry.value.billingReport.url"
                  download
                  ngbTooltip="{{ downloadBillingReportCsv }}"
                  ><span class="icon-df-download invoice-download-icon-span"></span
                ></a>
    
                <div
                  class="mr-3 text-muted billing-report-download-icon-container-disabled d-table text-center"
                  *ngIf="!(entry?.value?.billingReport?.url?.length > 0)"
                  ngbTooltip="{{ noBillingReportCsv }}"
                  href="javascript:void(0)"
                  ><div class="icon-df-download disabled-icon d-table-cell align-middle"></div
                ></div>
                </td>
            </tr>
        </tbody>
    </table>
    </div>
  </div>
  <div *ngIf="loadingError" class="d-flex error-message">
    <figure class="figure error-message-figure dropdown-width" data-test="kaliuk">
      <svg class="kaliuk kaliuk-big">
        <use href="/assets/images/svg_ico/icons.svg#kaliuk"></use>
      </svg>
      <figcaption class="figure-caption">
        <h4 i18n="@@amadeus-direct.avc-invoices.technical-error">
          There was a technical error
        </h4>
      </figcaption>
    </figure>
  </div>
</div>

<ng-template #noPermissions>
  <div class="d-flex justify-content-center">
  <figure class="figure" data-test="kaliuk">
    <svg class="kaliuk kaliuk-big">
      <use href="/assets/images/svg_ico/icons.svg#kaliuk"></use>
    </svg>
    <figcaption class="figure-caption">
      <h4 i18n="@@amadeus-direct.avc-dashboard.invoices.no-permissions">
        No data retrieved. Please request permission to access data.
      </h4>
    </figcaption>
  </figure>
  </div>
</ng-template>